(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jd-ai-chat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-jd-ai-chat]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const launcher = root.querySelector('.jd-ai-chat__launcher');
      const invitation = root.querySelector('.jd-ai-chat__invitation');
      const invitationClose = root.querySelector('.jd-ai-chat__invitation-close');
      const invitationChoices = root.querySelectorAll('[data-invite-prompt]');
      const invitationOpen = root.querySelector('[data-open-chat]');
      const panel = root.querySelector('.jd-ai-chat__panel');
      const close = root.querySelector('.jd-ai-chat__close');
      const form = root.querySelector('.jd-ai-chat__form');
      const input = form.querySelector('textarea');
      const messages = root.querySelector('.jd-ai-chat__messages');
      const suggestions = root.querySelectorAll('[data-prompt]');
      const history = [];
      const guides = {
        gold: '/pages/gold-buyer-kansas-city',
        bullion: '/pages/sell-gold-coins-and-gold-bars-to-joseph-diamonds-trusted-gold-buyer-in-overland-park-ks',
        silver: '/pages/sell-silver-bullion-near-me-joseph-diamonds',
        diamond: '/pages/diamond-buyers-in-kansas-city',
        jewelry: '/pages/sell-jewelry-in-kansas-city',
        estate: '/pages/estate-jewelry-buyer-kansas-city',
        rolex: '/pages/sell-rolex-overland-park',
        watch: '/pages/sell-your-luxury-watch-in-kansas-city-joseph-diamonds',
        gems: '/pages/sell-valuable-gems-in-kansas-city-gem-buyer-sapphires-rubies-emeralds',
        mail: '/pages/sell-your-valuables-by-mail-with-confidence-joseph-diamonds-overland-park'
      };

      const addMessage = (role, text, actions, replies) => {
        const bubble = document.createElement('div');
        bubble.className = 'jd-ai-chat__message jd-ai-chat__message--' + role;
        bubble.textContent = text;
        if (Array.isArray(actions) && actions.length) {
          const actionList = document.createElement('div');
          actionList.className = 'jd-ai-chat__actions';
          actions.slice(0, 3).forEach((action) => {
            if (!action || !action.url || !action.label) return;
            const anchor = document.createElement('a');
            anchor.href = action.url;
            anchor.textContent = action.label;
            actionList.appendChild(anchor);
          });
          bubble.appendChild(actionList);
        }
        messages.appendChild(bubble);
        messages.scrollTop = messages.scrollHeight;
      };

      let lastTopic = '';
      const actions = (types) => types.map((type) => ({
        url: type === 'book' ? root.dataset.appointmentUrl : type === 'estimate' ? root.dataset.photoUrl : root.dataset.contactUrl,
        label: type === 'book' ? 'Book a private appointment' : type === 'estimate' ? 'Send photos for an estimate' : 'Contact our team'
      }));
      const learn = (topic, label) => ({ url: guides[topic], label });

      const localAnswer = (message) => {
        const value = message.toLowerCase();
        const simple = value.trim().replace(/[?.!]/g, '');
        const has = (...words) => words.some((word) => value.includes(word));
        const karat = value.match(/\b(10|14|18|22|24)\s*k(?:arat)?\b/i);
        const weight = value.match(/\b(\d+(?:\.\d+)?)\s*(grams?|g|ounces?|oz|ozt|dwt)\b/i);
        const detail = [karat ? karat[1] + 'K' : '', weight ? weight[0] : ''].filter(Boolean).join(', ');

        if (has('address', 'located', 'location', 'where are you')) {
          lastTopic = 'location';
          return {
            text: 'We’re at 10560 Barkley Street, Suite 370, in Overland Park. Appointments recommended; walk-ins may be accommodated based on availability.',
            actions: actions(['book', 'contact'])
          };
        }
        if (has('hour', 'open today', 'when are you open', 'weekend', 'saturday', 'sunday')) {
          lastTopic = 'hours';
          return {
            text: 'We’re available Monday through Friday from 9:00 AM to 5:00 PM. Appointments recommended; walk-ins may be accommodated based on availability.',
            actions: actions(['book'])
          };
        }
        if (has('walk in', 'walk-in', 'without an appointment')) {
          lastTopic = 'appointment';
          return {
            text: 'Appointments recommended; walk-ins may be accommodated based on availability. We’re available Monday through Friday from 9:00 AM to 5:00 PM.',
            actions: actions(['book'])
          };
        }
        if (value.includes('appointment') || value.includes('book') || value.includes('visit')) {
          lastTopic = 'appointment';
          return {
            text: 'You can reserve a private evaluation online. Choose a convenient time, bring the items and any boxes, paperwork, or grading reports you have, and the team will evaluate everything with you. Those extras can help, but they aren’t required for every item.',
            actions: actions(['book'])
          };
        }
        if (value.includes('photo') || value.includes('picture') || value.includes('quote')) {
          lastTopic = 'estimate';
          return {
            text: 'Yes—you can send clear photos for an initial estimate. Include the front and back, hallmarks or stamps, and any box, paperwork, or grading report. Photos can help us determine whether the item is a fit, but a final purchase offer requires an in-person inspection.',
            actions: actions(['estimate'])
          };
        }
        if (has('mail', 'ship', 'shipping', 'out of state', 'not local', 'far away')) {
          lastTopic = 'mail';
          return {
            text: 'A mail-in evaluation may be possible, but every shipment requires approval first. Please send photos and a description, then wait for Joseph Diamonds to confirm eligibility and provide shipping instructions. Don’t ship valuables—or bullion—before receiving that approval.',
            actions: [learn('mail', 'How the mail-in process works'), ...actions(['estimate'])]
          };
        }
        if (value.includes('lab') && value.includes('diamond')) {
          lastTopic = 'lab diamond';
          return {
            text: 'We don’t purchase lab-grown diamonds. If the diamond is mounted in gold or platinum—or the piece also contains natural diamonds—we may still be able to evaluate those parts of the jewelry.',
            actions: []
          };
        }
        if (simple === 'gold' || simple === 'i have gold' || simple === 'sell gold') {
          lastTopic = 'gold';
          return {
            text: 'We buy gold in several forms. Is yours jewelry, coins or bullion, or something else?',
            actions: [],
            replies: ['Gold jewelry', 'Gold coins or bullion', 'Something else']
          };
        }
        if (simple === 'silver' || simple === 'i have silver' || simple === 'sell silver') {
          lastTopic = 'silver';
          return {
            text: 'We buy several types of silver. What do you have?',
            actions: [],
            replies: ['Silver coins or bullion', 'Sterling silver', 'I’m not sure']
          };
        }
        if (has('krugerrand', 'maple', 'eagle', 'buffalo', 'philharmonic', 'coin', 'bullion', 'bar')) {
          lastTopic = has('silver') ? 'silver bullion' : 'gold bullion';
          return {
            text: 'We buy gold and silver coins and bullion. The evaluation considers verified metal content and the current market, but we also check whether a coin has collectible value above its metal value. Please don’t clean the coins before bringing them in.',
            actions: [...actions(['book']), learn(has('silver') ? 'silver' : 'bullion', has('silver') ? 'Silver bullion guide' : 'Gold coins & bullion guide')]
          };
        }
        if (has('gold', 'silver', 'sterling', 'platinum', 'karat', '10k', '14k', '18k', '22k', '24k')) {
          lastTopic = has('silver', 'sterling') ? 'silver' : has('platinum') ? 'platinum' : 'gold';
          return {
            text: detail
              ? 'Yes, we can evaluate your ' + detail + ' item. We’ll verify the purity and net precious-metal weight, then consider the current market and whether the piece has additional designer, collectible, or resale value. That physical testing is what lets us give you an exact offer.'
              : 'Yes, we buy gold, silver, sterling, and platinum items—including broken or worn jewelry. We test the metal, verify its net weight and purity, and also check whether the piece is worth more intact than as precious metal.',
            actions: [...actions(['book']), learn(lastTopic === 'silver' ? 'silver' : 'gold', lastTopic === 'silver' ? 'Learn about selling silver' : 'Learn about selling gold')]
          };
        }
        if (value.includes('rolex') || value.includes('watch')) {
          lastTopic = 'watch';
          const noPapers = has('no box', 'without box', 'no papers', 'without papers');
          if (simple === 'watch' || simple === 'i have a watch' || simple === 'sell a watch') {
            return {
              text: 'What kind of watch is it?',
              actions: [],
              replies: ['Rolex', 'Another luxury brand', 'I’m not sure']
            };
          }
          return {
            text: noPapers
              ? 'That’s okay—a Rolex can still be evaluated without its box or papers. We’ll examine authenticity, reference, age, condition, completeness, and current demand. If you have service records or extra links, bring those, but don’t have the watch polished before the evaluation.'
              : 'We buy Rolex and other select luxury watches. The evaluation looks at authenticity, reference, age, condition, completeness, service history when known, and current market demand. Box and papers can help, but they aren’t always required.',
            actions: [...actions(['book']), learn(value.includes('rolex') ? 'rolex' : 'watch', value.includes('rolex') ? 'Rolex selling guide' : 'Luxury watch guide')]
          };
        }
        if (value.includes('estate') || has('inherited', 'inheritance', 'collection', 'several boxes')) {
          lastTopic = 'estate';
          return {
            text: 'We can review the collection together—you don’t need to sort, clean, or identify everything first. Estate evaluations can include jewelry, natural diamonds, watches, gemstones, coins, bullion, and precious metals. For several pieces, one private appointment is usually the easiest approach.',
            actions: [...actions(['book']), learn('estate', 'Estate & inherited jewelry guide')]
          };
        }
        if (value.includes('diamond')) {
          lastTopic = 'diamond';
          if (simple === 'diamond' || simple === 'i have a diamond' || simple === 'sell a diamond') {
            return {
              text: 'Is the diamond natural or lab-grown? If you aren’t sure, that’s okay—we can help determine the right next step.',
              actions: [],
              replies: ['Natural diamond', 'Lab-grown diamond', 'I’m not sure']
            };
          }
          return {
            text: 'We evaluate natural loose and mounted diamonds. Size is only one factor; cut, color, clarity, condition, the mounting, any grading report, and current resale demand can all affect value. Do you know whether yours is natural or lab-grown?',
            actions: [...actions(['book']), learn('diamond', 'Natural diamond selling guide')]
          };
        }
        if (has('sapphire', 'ruby', 'emerald', 'gemstone', 'colored stone')) {
          lastTopic = 'gemstone';
          return {
            text: 'We consider significant natural sapphires, rubies, and emeralds—especially fine stones set in quality jewelry or loose stones with respected gemological reports. Value depends heavily on whether the stone is natural, its size, color, clarity, treatments, origin when known, and overall quality. We generally don’t purchase inexpensive loose commercial gemstones.',
            actions: [learn('gems', 'Fine gemstone selling guide'), ...actions(['estimate'])]
          };
        }
        if (has('obligated', 'obligation', 'have to sell', 'must sell')) {
          return {
            text: 'No. There’s no obligation to sell simply because we evaluate your items or make an offer. We’ll explain what we’re interested in purchasing, and you decide whether you’d like to proceed.',
            actions: actions(['book'])
          };
        }
        if (has('paid', 'payment', 'cash', 'check', 'same day')) {
          return {
            text: 'If you accept the offer, payment can generally be completed at the time of the transaction. For questions about the payment method for a particular transaction, contact the office directly.',
            actions: actions(['contact'])
          };
        }
        if (has('how does it work', 'selling process', 'what happens', 'evaluation process')) {
          return {
            text: 'The process is straightforward: bring or submit information about your items, we evaluate the factors that actually affect their resale value, and we make an offer on the pieces we’re interested in purchasing. You’re free to accept or decline—there’s no pressure or obligation.',
            actions: actions(['book', 'estimate'])
          };
        }
        if (has('jewelry', 'ring', 'bracelet', 'necklace', 'earring', 'tiffany', 'cartier', 'van cleef')) {
          lastTopic = 'jewelry';
          return {
            text: 'We evaluate fine, designer, vintage, antique, estate, and inherited jewelry. We look beyond the metal and stones—maker, craftsmanship, condition, age, and resale demand can add value, especially for signed pieces. Clear photos of the whole piece and its markings are useful for an initial review.',
            actions: [...actions(['book']), learn('jewelry', 'Fine jewelry selling guide')]
          };
        }
        if (has('appraisal', 'insurance value', 'replacement value')) {
          lastTopic = 'appraisal';
          return {
            text: 'Our evaluation is for a potential purchase offer, not an insurance or replacement-value appraisal. If you’re considering selling, we can inspect the item and explain the factors affecting its current resale value.',
            actions: actions(['book'])
          };
        }
        if (has('how much', 'worth', 'value', 'offer', 'pay')) {
          return {
            text: 'An exact offer depends on what the item is and what we can verify in person. Precious metals depend heavily on purity and net weight; diamonds, jewelry, coins, and watches can also have value based on condition, brand, rarity, and resale demand. Photos can provide an initial idea, while an appointment is the route to an exact purchase offer.',
            actions: actions(['book', 'estimate'])
          };
        }
        if (has("i’m not sure", "i'm not sure", 'im not sure', 'not sure', 'something else') && lastTopic) {
          return {
            text: 'That’s completely fine. Send a few clear photos of the item and any markings, signatures, paperwork, boxes, or certificates you have. We can use those to determine whether it’s something we evaluate and recommend the right next step.',
            actions: actions(['estimate'])
          };
        }
        if (has('yes', 'no', 'it is', 'i do', "don't", 'ready') && lastTopic) {
          return {
            text: 'Thanks—that helps. The best next step is to let us see the item so we can give you guidance based on the actual piece. You can start with photos if you want a preliminary review, or book a private appointment if you’re ready for an exact offer.',
            actions: actions(['estimate', 'book'])
          };
        }
        return {
          text: 'Tell me a little about what you have—such as the item type, metal or brand, any markings, and whether you’re looking to sell now or just get an initial idea. I’ll point you toward the most useful next step.',
          actions: []
        };
      };

      const ask = async (message) => {
        addMessage('visitor', message);
        history.push({ role: 'user', content: message });
        input.value = '';
        input.disabled = true;
        try {
          let answer;
          if (root.dataset.endpoint) {
            const response = await fetch(root.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify({
                message,
                history: history.slice(-10),
                page: { title: document.title, url: window.location.href }
              })
            });
            if (!response.ok) throw new Error('Request failed');
            answer = await response.json();
          } else {
            answer = localAnswer(message);
          }
          addMessage('assistant', answer.text, answer.actions || (answer.link ? [answer.link] : []), answer.replies || []);
          history.push({ role: 'assistant', content: answer.text });
        } catch {
          addMessage('assistant', root.dataset.error);
        } finally {
          input.disabled = false;
          input.focus();
        }
      };

      const openPanel = (focusInput = true) => {
        invitation.hidden = true;
        panel.hidden = false;
        launcher.setAttribute('aria-expanded', 'true');
        if (!messages.children.length) addMessage('assistant', root.dataset.greeting);
        if (focusInput && !window.matchMedia('(max-width: 767px)').matches) input.focus();
      };

      const closePanel = () => {
        panel.hidden = true;
        launcher.setAttribute('aria-expanded', 'false');
        launcher.focus();
      };

      invitationOpen.addEventListener('click', () => openPanel(true));
      launcher.addEventListener('click', () => panel.hidden ? openPanel(true) : closePanel());
      invitationClose.addEventListener('click', () => {
        invitation.hidden = true;
        try { sessionStorage.setItem('jdAiChatInvitationSeen', 'true'); } catch {}
      });
      invitationChoices.forEach((button) => button.addEventListener('click', () => {
        invitation.hidden = true;
        try { sessionStorage.setItem('jdAiChatInvitationSeen', 'true'); } catch {}
        openPanel(true);
        ask(button.dataset.invitePrompt);
      }));
      close.addEventListener('click', closePanel);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const message = input.value.trim();
        if (message) ask(message);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          form.requestSubmit();
        }
        if (event.key === 'Escape') closePanel();
      });
      suggestions.forEach((button) => button.addEventListener('click', () => ask(button.dataset.prompt)));

    });
  })();

  } catch(e) { console.error(e); }
})();
})();
